import React from 'react';

import Card from '../../Shared/UI/Card/components/Card';
import styles from './GroupCard.module.scss';

const GroupCard = ({ group }) => {
  const { path, imagePath, name, description, canView } = group;

  return (
    <Card
      disabled={!canView}
      onClick={canView ? () => window.location.assign(path) : null}
    >
      <img className={styles.img} src={imagePath} />
      <div className={styles.textContainer}>
        <p className={styles.title}>{name}</p>
        <p className={styles.description}>{description}</p>
      </div>
      {!canView && <span className={styles.badge}>Members Only</span>}
    </Card>
  );
};

export default GroupCard;
